import { get } from "../../xhr/api";

export const getWalletDetails = () => {
  return get("api/declaration-system/declarations/wallet", {}, true);
};
